<div class="policy-config">
    <div *ngIf="isLoading$ | async" class="policy-config-spinner">
        <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
    </div>
    <div *ngIf="!policyModel && (isLoading$ | async) === false">
        <app-no-data></app-no-data>
    </div>

    <div *ngIf="(isLoading$ | async) === false" class="policy-config-content">
        <app-sidepanel-tabs
            *ngIf="tabs.length > 0"
            [tabs]="tabs"
            [changeTabIndex]="changeCurrentTabIndex"
            [vertical]="true"
            (tabOnSelection)="onTabSelect($event)">
        </app-sidepanel-tabs>

        <div class="scollable-form form-class">
            <app-general-settings
                *ngIf="currentTabIndex === 0"
                [policyModel]="policyModel"
                [integrationModel]="integrationModel"
                [editable]="canEdit()"
                (goBack)="backToPolicies()"
                (notifyChanges)="changesWereDoneUpdate($event)"
                (policyUpdated)="updatePolicy($event)">
            </app-general-settings>
            <app-trusted-domains
                *ngIf="currentTabIndex === 1"
                [policyModel]="policyModel"
                [integrationModel]="integrationModel"
                [editable]="canEdit()"
                (goBack)="backToPolicies()"
                (policyUpdated)="updatePolicy($event)"
                (notifyChanges)="changesWereDoneUpdate($event)">
            </app-trusted-domains>
            <app-policy-endpoint-filtering
                *ngIf="currentTabIndex === 2"
                [policyModel]="policyModel"
                [integrationModel]="integrationModel"
                [editable]="canEdit()"
                (goBack)="backToPolicies()"
                (notifyChanges)="changesWereDoneUpdate($event)"
                (policyUpdated)="updatePolicy($event)">
            </app-policy-endpoint-filtering>
            <app-environments
                *ngIf="currentTabIndex === 3"
                [environments]="environments"
                [integrationId]="integrationId"
                [platform]="policyModel.platform"
                [currentPolicyId]="policyId"
                [currentPolicyType]="policyModel.type"
                (updateEnvironments)="updateEnvironments($event)"
                [editable]="canEdit()">
            </app-environments>
            <app-policy-connectors
                *ngIf="currentTabIndex === 4"
                [policyModel]="policyModel"
                [integrationModel]="integrationModel"
                [editable]="canEdit()"
                (goBack)="backToPolicies()"
                (policyUpdated)="updatePolicy($event)"
                (notifyChanges)="changesWereDoneUpdate($event)">
            </app-policy-connectors>
        </div>
    </div>
</div>
